import { actions } from 'store/actions/jobActions';
import constants from 'constants';
import u from 'updeep';

const { JOB_PHASES } = constants;

const initialState = {
  phase: JOB_PHASES.IDLE,
  jobGuid: null,
  job: null,
  model: null,
  downloadURL: null,
  pollStartedAt: null,
  pollFailures: 0,
  downloadAttempts: 0,
};

const jobReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.SET_JOB_PHASE:
      return u({ phase: action.payload }, state);

    // Payloads replace rather than merge — updeep deep-merges objects by default
    // and a later job body must not inherit fields from an earlier one.
    case actions.SET_JOB:
      return u({ job: u.constant(action.payload) }, state);

    case actions.SET_JOB_MODEL:
      return u({ model: u.constant(action.payload) }, state);

    case actions.SET_JOB_GUID:
      return u({ jobGuid: action.payload }, state);

    case actions.SET_POLL_STARTED_AT:
      return u({ pollStartedAt: action.payload }, state);

    case actions.SET_POLL_FAILURES:
      return u({ pollFailures: action.payload }, state);

    case actions.SET_DOWNLOAD_ATTEMPTS:
      return u({ downloadAttempts: action.payload }, state);

    case actions.SET_DOWNLOAD_URL:
      return u({ downloadURL: action.payload }, state);

    case actions.CLEAR_JOB:
      return { ...initialState };

    default:
      return state;
  }
};

export { jobReducer, initialState };
